module.exports = __webpack_public_path__ + "media/images/iconPlus__okGreen-89049bf17f0a7089dfba6b50dd4edf50.png";